// src/utils/lynProgress.js
// Persists Learn-Your-Notes GAME progress (completion + best star rating) so the
// Note Trail map can light up finished buildings and unlock the next one.

import { LEVEL_ORDER, LEVELS } from "../data/lynLevels";

const KEY = "pwp-lyn-progress-v1";

export function loadProgress() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

// Save a finished run; keeps the BEST star count for that level.
export function saveLevelResult(levelId, stars) {
  const p = loadProgress();
  const prevStars = (p[levelId] && p[levelId].stars) || 0;
  p[levelId] = { completed: true, stars: Math.max(prevStars, stars || 0) };
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch {}
  return p;
}

export function levelStars(levelId) {
  const p = loadProgress();
  return (p[levelId] && p[levelId].stars) || 0;
}

export function isLevelDone(levelId) {
  const p = loadProgress();
  return !!(p[levelId] && p[levelId].completed);
}

// A level is unlocked if it's the first, or the previous level is completed.
export function isLevelUnlocked(levelId) {
  const idx = LEVEL_ORDER.indexOf(Number(levelId));
  if (idx <= 0) return true;
  return isLevelDone(LEVEL_ORDER[idx - 1]);
}

// 0..1 — how much of Treble Town's magic is restored (avg stars / 3).
export function townRestoredFraction() {
  const playable = LEVEL_ORDER.filter((id) => LEVELS[id] && !LEVELS[id].comingSoon);
  if (!playable.length) return 0;
  const total = playable.reduce((s, id) => s + levelStars(id), 0);
  return Math.min(1, total / (playable.length * 3));
}